














import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import Element from './Element.vue';

@Component({
  components: {
    Element,
  },
  computed: {
    ...mapGetters(['bonusElementsWithVisited', 'allUnlocked']),
  },
})
export default class Elements extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BonusElements.vue